import lib from '@/library'
import config from '@/config'

async function fetchRecommendedEventsArray (isLive = null, fromOffset = config.app.autoconf.PLAYER_PERSONALISATION.recommendedLiveEventsFromOffset) {
  let userId = (localStorage.customer === 'undefined' ? null : localStorage.customer)
  try {
    const params = {
      'uid': userId,
      'live': isLive
    }
    if (fromOffset) {
      params.fromOffset = fromOffset
    }
    const response = await lib.rpcService.callBroker('personalization', 'getrecommendedeventsarray', params)
    if (response.result) {
      return response.result
    }
  } catch (error) {
    console.error(error)
  }
}

export default {
  fetchRecommendedEventsArray
}



// WEBPACK FOOTER //
// ./src/library/personalization/recommended.js